require('./backupModal.i18n.json');
require('./backupModal.tpl.html');
require('./backupRepository.js');

/*@ngInject*/
const BackupModalController = function ($rootScope, $scope, coreMediator, localization, coreConstant, configurationActionsUtil) {
    localization.getTranslationByKey('backup').then(function (translations) {
        $scope.viewModel = {
            configurationContentList: [],
            configurationContentPrompt: translations.configurationContentPrompt,
            selectedConfigurationContent: '',
            title: translations.title,
            cancelButton: translations.cancelButton,
            backupButton: translations.backupButton
        };

        function loadConfigurationContent() {
            coreMediator.getDynamicDataSetItems({name: 'Database Section Names'}).then(function (databaseSectionNames) {
                $scope.viewModel.configurationContentList = databaseSectionNames;
            });
        }

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $scope.canEnableConfirmButton = function () {
            return $scope.viewModel.selectedConfigurationContent;
        };

            $scope.onBackup = function () {
                $scope.$dismiss();
                configurationActionsUtil.backup($scope.viewModel.selectedConfigurationContent.name, $scope.viewModel.selectedConfigurationContent.name,
                    translations.loadingBar, translations.successMessage);
            };

            loadConfigurationContent();
            $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
        });
    };

angular.module('ums.configuration')
    .controller('backupModalController', BackupModalController);
